import { render } from "./EditSchedule.vue?vue&type=template&id=39bd9d16"
import script from "./EditSchedule.vue?vue&type=script&lang=js"
export * from "./EditSchedule.vue?vue&type=script&lang=js"
/* custom blocks */
import block0 from "@/locales/views/service_provider/services/container_op/edit_schedule.yml?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Falejo%2FDevelopment%2FAT%2FApps%2Fagrotecchain_vue%2Fsrc%2Fviews%2Fservice_provider%2Fservices%2Fcontainer_op%2FEditSchedule.vue&lang=yaml"
if (typeof block0 === 'function') block0(script)
import block1 from "@/locales/models/container_scheduled_service.yml?vue&type=custom&index=1&blockType=i18n&issuerPath=%2Fhome%2Falejo%2FDevelopment%2FAT%2FApps%2Fagrotecchain_vue%2Fsrc%2Fviews%2Fservice_provider%2Fservices%2Fcontainer_op%2FEditSchedule.vue&lang=yaml"
if (typeof block1 === 'function') block1(script)


import exportComponent from "/home/alejo/Development/AT/Apps/agrotecchain_vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__